import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageLogInComponent } from './pagesAdmin/page-log-in/page-log-in.component';
import { CommonModule } from '@angular/common';
import {
  provideRouter,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {MatSelectModule} from '@angular/material/select';
import { PageMenuListComponent } from './pagesAdmin/page-menu-list/page-menu-list.component';
import { AdminHeaderComponent } from './adminComponents/admin-header/admin-header.component';
import { NavigationAdminComponent } from './adminComponents/navigation-admin/navigation-admin.component';
import { AdminLayoutComponent } from './layout-components/admin-layout/admin-layout.component';
import { DropdownAdminComponent } from './adminComponents/dropdown-admin/dropdown-admin.component';
import { SearchAdminComponent } from './adminComponents/search-admin/search-admin.component';
import { ItemRowAdminComponent } from './adminComponents/item-row-admin/item-row-admin.component';
import { DropdownMiniAdminComponent } from './adminComponents/dropdown-mini-admin/dropdown-mini-admin.component';
import { PageAdminCategoriesComponent } from './pagesAdmin/page-admin-categories/page-admin-categories.component';
import { MenuListHeaderAdminComponent } from './adminComponents/menu-list-header-admin/menu-list-header-admin.component';
import { CatergoryRowComponentComponent } from './adminComponents/catergory-row-component/catergory-row-component.component';
import { CategoryUploadImageComponent } from './adminComponents/category-upload-image/category-upload-image.component';
import { PercentageBoxComponent } from './adminComponents/percentage-box/percentage-box.component';
import { PageNavigationComponent } from './adminComponents/page-navigation/page-navigation.component';
import { PageAddItemComponent } from './pagesAdmin/page-add-item/page-add-item.component';
import { SaveButtonComponent } from './adminComponents/save-button/save-button.component';
import { CategoriesHeaderAdminComponent } from './adminComponents/categories-header-admin/categories-header-admin.component';
import { SingleImageCategoriesComponent } from './adminComponents/single-image-categories/single-image-categories.component';
import { PageAddCategoryComponent } from './pagesAdmin/page-add-category/page-add-category.component';
import { PageItemsOrderAdminComponent } from './pagesAdmin/page-items-order-admin/page-items-order-admin.component';
import { CdkDropList, CdkDrag} from '@angular/cdk/drag-drop';
import { PageCategoriesOrderComponent } from './pagesAdmin/page-categories-order/page-categories-order.component';
import { PageExportMenuComponent } from './pagesAdmin/page-export-menu/page-export-menu.component';
import { FormsModule } from '@angular/forms';
import { AdminSuccessMessageComponent } from './adminComponents/admin-success-message/admin-success-message.component';
import { UploadImageComponent } from './adminComponents/upload-image/upload-image.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { BrandNameComponent } from './adminComponents/brand-name/brand-name.component';
import { LogoCircleComponent } from './adminComponents/logo-circle/logo-circle.component';
import { PasswordInputComponent } from './adminComponents/password-input/password-input.component';
import { PageAddCouponComponent } from './pagesAdmin/page-add-coupon/page-add-coupon.component';
import { CouponHeaderComponent } from './adminComponents/coupon-header/coupon-header.component';
import { CouponRowComponent } from './adminComponents/coupon-row/coupon-row.component';

@NgModule({
  declarations: [
    PageLogInComponent,
    PageMenuListComponent,
    AdminHeaderComponent,
    NavigationAdminComponent, 
    AdminLayoutComponent,
    DropdownAdminComponent,
    SearchAdminComponent,
    UploadImageComponent,
    ItemRowAdminComponent,
    DropdownMiniAdminComponent,
    PageAdminCategoriesComponent,
    MenuListHeaderAdminComponent,
    CatergoryRowComponentComponent,
    CategoryUploadImageComponent,
    PercentageBoxComponent,
    PageNavigationComponent,
    CategoriesHeaderAdminComponent,
    SingleImageCategoriesComponent,
    PageAddItemComponent,
    SaveButtonComponent,
    PageAddCategoryComponent,
    PageItemsOrderAdminComponent,
    PageCategoriesOrderComponent,
    PageExportMenuComponent,
    AdminSuccessMessageComponent,
    BrandNameComponent,
    LogoCircleComponent,
    PasswordInputComponent,
    PageAddCouponComponent,
    CouponHeaderComponent,
    CouponRowComponent
  ],
  exports: [
    PageLogInComponent,
    RouterModule,
    PageMenuListComponent,
    AdminHeaderComponent,
    NavigationAdminComponent,
    AdminLayoutComponent,
    DropdownAdminComponent,
    SearchAdminComponent,
    ItemRowAdminComponent,
    UploadImageComponent,
    DropdownMiniAdminComponent,
    PageAdminCategoriesComponent,
    MenuListHeaderAdminComponent,
    CatergoryRowComponentComponent,
    CategoryUploadImageComponent,
    PercentageBoxComponent,
    PageNavigationComponent,
    CategoriesHeaderAdminComponent,
    SingleImageCategoriesComponent,
    PageAddItemComponent,
    SaveButtonComponent,
    PageAddCategoryComponent,
    PageItemsOrderAdminComponent,
    PageCategoriesOrderComponent,
    PageExportMenuComponent,
    AdminSuccessMessageComponent,
    BrandNameComponent,
    LogoCircleComponent,
    PasswordInputComponent,
    PageAddCouponComponent,
    CouponHeaderComponent,
    CouponRowComponent
  ],
  bootstrap: [],
  imports: [
    CommonModule,
    RouterOutlet,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatSelectModule,
    CdkDropList, 
    CdkDrag,
    FormsModule,
    HttpClientModule,
    ImageCropperComponent
    
  ],
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    provideAnimationsAsync(),
  ],
})
export class adminModule {}
